exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.user-list-popover{padding:.5em\n}\n.user-list-popover .user-list-row{padding:.25em;display:flex;flex-direction:row\n}\n.user-list-popover .user-list-row .user-list-names{display:flex;flex-direction:column;margin-left:.5em;min-width:5em\n}\n.user-list-popover .user-list-row .user-list-names img{width:1em;height:1em\n}\n.user-list-popover .user-list-row .user-list-screen-name{font-size:9px\n}", ""]);

// exports
